import type { ReactElement, Ref } from 'react';
import { useEffect, useRef } from 'react';
import type { ParallaxCardHoverProps, ParallaxCardHoverRef } from './ParallaxCardHover.data';
import styles from './ParallaxCardHover.module.scss';

import Card from 'react-animated-3d-card';
import gsap from 'gsap';
import useWindowSize from '../../../hooks/useWindowSize';

export default function ParallaxCardHover({
  style,
  imgSrcBack,
  imgSrcFront,
  ref,
}: ParallaxCardHoverProps & { ref?: Ref<ParallaxCardHoverRef> }): ReactElement {
  // https://codepen.io/kirtisoni12/pen/vMEBPy

  const div0Ref = useRef(null);
  const div1Ref = useRef(null);
  const div2Ref = useRef(null);

  // I can't explain it but if this step get removed,
  // the performances are really bad
  useEffect(() => {
    setTimeout(() => {
      if (div0Ref.current) {
        gsap.set([div0Ref.current, div1Ref.current, div2Ref.current], {
          height: 0,
          width: 0,
        });
      }
    }, 500);
  }, []);

  const { width: windowWidth } = useWindowSize();

  return (
    <Card
      ref={ref}
      isStatic={windowWidth < 800}
      cursorPointer={false}
      style={{
        width: 'var(--width)',
        height: 'var(--height)',
        backgroundImage: `url(${imgSrcBack})`,
        backgroundSize: 'contain',
        userSelect: 'none',
        ...style,
      }}
    >
      <div>
        <div ref={div0Ref} className={styles.emptyDivForDepthEffect} />
      </div>
      <div>
        <div ref={div1Ref} className={styles.emptyDivForDepthEffect} />
      </div>
      <div>
        <div ref={div2Ref} className={styles.emptyDivForDepthEffect} />
      </div>

      <div>
        <img
          alt="front of the card"
          src={imgSrcFront}
          style={{
            // position: 'absolute',
            top: 0,
            left: 0,
            width: 'var(--width)',
            height: 'var(--height)',
          }}
        />
      </div>
    </Card>
  );
}
